/**
 * Helpers over the file-tree payload shape (CaseFileService::nodePayload):
 *   folders: { id, name, kind: 'folder', restricted, modified, children: [...] }
 *   files:   { id, name, kind: 'file',   restricted, modified, ext, size }
 */

/** Count file nodes in a tree payload (folders excluded). */
export const countTreeFiles = (nodes) =>
  nodes.reduce(
    (total, node) => total + (node.kind === 'folder' ? countTreeFiles(node.children ?? []) : 1),
    0,
  );

/**
 * The files in the same folder as `fileId`, in the order the tree shows them
 * (the API sends folders first, then files by name). The preview steps through
 * this list (OL-151). With a search term, only matching files count, plus the
 * open file itself.
 */
export const siblingFiles = (nodes, fileId, term = '') => {
  const folderOf = (list) => {
    if (list.some((node) => node.id === fileId && node.kind === 'file')) return list;
    for (const node of list) {
      if (node.kind === 'folder') {
        const found = folderOf(node.children ?? []);
        if (found) return found;
      }
    }
    return null;
  };

  const needle = term.trim().toLowerCase();

  return (folderOf(nodes) ?? []).filter(
    (node) => node.kind === 'file' && (!needle || node.id === fileId || node.name.toLowerCase().includes(needle)),
  );
};

/**
 * True when a react-arborist node is the folder `folderId` or sits anywhere
 * inside it. Nodes link to their parent up to the library's internal root.
 */
export const isInsideFolder = (node, folderId) => {
  for (let current = node; current && !current.isRoot; current = current.parent) {
    if (current.id === folderId) return true;
  }
  return false;
};
